export enum OtpProvider {
    SMS = 'sms',
    ZALO = 'zalo',
    CALL = 'call',
    PIN_CODE = 'pin_code'
}
